export function getView(isSupport) {
  return isSupport ? 'Support' : 'Admin'
}
